import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CompanyService } from './../../../../../providers/services/company.service';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CartService } from '../../../../../providers/services/cart.service';
import { UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductService } from '../../../../../providers/services/product.service';
import { AbstractProductDetails } from '../abstract-product-details';
import { takeUntil } from 'rxjs/operators';
import { ProductRatingService } from '@shop/app/providers/services/product-rating.service';
import { Company } from '@pdp/common';
import { NgIf, NgClass, NgFor, LowerCasePipe, DecimalPipe } from '@angular/common';
import { BarRatingModule } from 'ngx-bar-rating';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'pdp-quick-view',
    templateUrl: './quick-view.component.html',
    styleUrls: ['./quick-view.component.scss', '../abstract-product-details.scss'],
    imports: [NgIf, BarRatingModule, NgClass, NgFor, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatButton, RouterLink, LowerCasePipe, DecimalPipe]
})
export class QuickViewComponent extends AbstractProductDetails {

  public company: Company;
  
  constructor(public carService: CartService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public productService: ProductService,
              public formBuilder: UntypedFormBuilder,
              private companyService: CompanyService,
              public ratingService: ProductRatingService,
              private dialogRef: MatDialogRef<QuickViewComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
                super(carService, productService, router, activatedRoute, formBuilder, ratingService);
      if (data) {
        this.companyService.getValue.pipe(takeUntil(this.unsubscribe)).subscribe((company: Company)=>{
          this.company = company;
        })
        productService.findOne(data.product.id).pipe(takeUntil(this.unsubscribe))
        .subscribe(currentProduct => {
          this.product = currentProduct;
          this.prepareProductInfo();
        });

      }
  }

  public addToCart(){
    super.addToCart();
    this.close();
  }

  close() {
      this.dialogRef.close();
  }

}
